"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GradeAndFeedbackCustomTime = void 0;
var _react = require("react");
var _hooks = require("../../../../../../../hooks");
var _DateTimePickers = require("../../../../../../../UI/DateTimePickers");
var _TaskManager = require("../../../../../TaskManager.provider");
var _GradeAndFeedbackCustomTime = _interopRequireDefault(require("./GradeAndFeedbackCustomTime.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var GradeAndFeedbackCustomTime = function GradeAndFeedbackCustomTime(props) {
  var _props$minDate = props.minDate,
    minDate = _props$minDate === void 0 ? new Date() : _props$minDate,
    maxDate = props.maxDate;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    task = _useContext.task,
    setTask = _useContext.setTask,
    setIsChanged = _useContext.setIsChanged,
    unitData = _useContext.unitData,
    getLabel = _useContext.getLabel;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var isTimeEnable = (task === null || task === void 0 ? void 0 : task.taskType) === 'exam';
  var toDay = (0, _react.useRef)(new Date());
  var dpMinDate = new Date(Math.max(minDate.getTime(), toDay.current.getTime()));
  var dpMaxDate = maxDate || (unitData === null || unitData === void 0 ? void 0 : unitData.schoolYear.endDate);
  var handleDateChange = function handleDateChange(date) {
    setIsChanged(true);
    setTask(_objectSpread(_objectSpread({}, task), {}, {
      feedbackDate: date
    }));
  };
  var styles = (0, _GradeAndFeedbackCustomTime.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-TaskManager__grade-and-feedback-custom-time'],
    children: isTimeEnable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.DateTimePicker, {
      minDateTime: dpMinDate,
      maxDateTime: dpMaxDate,
      anchorSubTextDate: getLabel('text_label_date'),
      anchorSubTextTime: getLabel('text_label_time'),
      datePickerTitle: "",
      timePickerTitle: getLabel('text_label_time'),
      dateTime: task === null || task === void 0 ? void 0 : task.feedbackDate,
      onChange: handleDateChange,
      minutesStep: 5,
      isDisabled: task === null || task === void 0 ? void 0 : task.isReadOnly,
      btnProps: {
        customStyle: {
          width: isMobileView ? '100%' : 'auto'
        }
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.DatePicker, {
      view: "menu",
      minDate: dpMinDate,
      maxDate: dpMaxDate,
      anchorSubText: getLabel('text_label_date'),
      selectedDate: task === null || task === void 0 ? void 0 : task.feedbackDate,
      onChange: handleDateChange,
      isDisabled: task === null || task === void 0 ? void 0 : task.isReadOnly
    })
  });
};
exports.GradeAndFeedbackCustomTime = GradeAndFeedbackCustomTime;